import React, { useEffect, useState } from "react";
import { Card, Button, Spin, Empty } from "antd";
import { RightOutlined, LoadingOutlined, CalendarOutlined } from "@ant-design/icons";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getChildren } from "services/holistic";
import MeetingBooking, { MyMeetings } from "./MeetingBooking";

// Parent landing: pick a child, then view that child's College-Prep report (read-only).
function CollegePrepParent() {
  const navigate = useNavigate();
  const [sp] = useSearchParams();
  const [children, setChildren] = useState([]);
  const [loading, setLoading] = useState(true);
  const [meetingOpen, setMeetingOpen] = useState(false);
  const [meetingRefresh, setMeetingRefresh] = useState(0);

  useEffect(() => {
    getChildren()
      .then((d) => {
        setChildren(d || []);
        // Нүүрний "Уулзалт захиалах"-аас ирвэл (?book=1) захиалгын цонхыг шууд нээнэ
        if (sp.get("book") && (d || []).length) setMeetingOpen(true);
      })
      .finally(() => setLoading(false));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (loading)
    return (
      <div className="pt-[120px] flex justify-center">
        <Spin indicator={<LoadingOutlined style={{ fontSize: 28 }} />} />
      </div>
    );

  return (
    <div className="max-w-2xl mx-auto px-4 pt-[80px] pb-16">
      <h1 className="text-2xl font-bold text-primary mb-1">Их сургуулийн өргөдөл</h1>
      <p className="text-secondary text-sm mb-6">
        Хүүхдээ сонгоод цогц үнэлгээний тайланг үзнэ үү.
      </p>

      {children.length === 0 ? (
        <Empty description="Хүүхэд олдсонгүй" />
      ) : (
        children.map((c) => (
          <Card
            key={c.id}
            hoverable
            className="mb-3"
            onClick={() => navigate(`/college-prep/report?student=${c.id}`)}
          >
            <div className="flex items-center justify-between">
              <div className="font-semibold">
                {c.lastName} {c.firstName}
              </div>
              <Button type="primary" icon={<RightOutlined />}>
                Тайлан үзэх
              </Button>
            </div>
          </Card>
        ))
      )}

      {/* Meeting booking */}
      {children.length > 0 && (
        <Card className="mt-6" bodyStyle={{ padding: 16 }}>
          <div className="text-lg font-semibold text-primary mb-2">
            Зөвлөгч багштай уулзалт
          </div>
          <p className="text-secondary text-sm mb-3">
            Их сургуулийн өргөдлийн зөвлөгч багштай ганцаарчлан гурвалсан уулзалт хийх боломжтой.
          </p>
          <Button
            type="primary"
            size="large"
            icon={<CalendarOutlined />}
            onClick={() => setMeetingOpen(true)}
          >
            Уулзалт товлох
          </Button>
          <MyMeetings refresh={meetingRefresh} />
        </Card>
      )}

      <MeetingBooking
        open={meetingOpen}
        onClose={() => { setMeetingOpen(false); setMeetingRefresh((x) => x + 1); }}
        children={children}
      />
    </div>
  );
}

export default CollegePrepParent;
